<section class="hero-section">
  <section>
    <h1 class="glitch" [attr.data-text]="mainTitle">{{mainTitle}}</h1>
    <div id="typed-strings">
      <p *ngFor="let subtitle of subtitles">{{subtitle}}</p>
    </div>
    <span id="typed"></span>
  </section>
</section>
